export const STALE_ACTIVE_PHONE_CALL_SELF_HEAL_MS = 15_000;

type Params = {
  phoneCallState?: string;
  isConnected?: boolean;
  hasConnection: boolean;
  hasLocalStreams: boolean;
  staleForMs: number;
};

export function shouldSelfHealStaleActivePhoneCall({
  phoneCallState,
  isConnected,
  hasConnection,
  hasLocalStreams,
  staleForMs,
}: Params): boolean {
  return phoneCallState === 'active'
    && !isConnected
    && (!hasConnection || !hasLocalStreams)
    && staleForMs >= STALE_ACTIVE_PHONE_CALL_SELF_HEAL_MS;
}
